import React from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea: React.FC<TextareaProps> = ({ className = '', ...props }) => {
  return (
    <textarea
      className={`
        block w-full rounded-md border-gray-300 shadow-sm
        focus:border-blue-500 focus:ring-blue-500 focus:ring-1
        sm:text-sm resize-vertical min-h-[80px]
        ${className}
      `}
      {...props}
    />
  );
};

export default Textarea;